import React from 'react';

import Layout from '../components/layout/Layout';

const Home = () => (
    <Layout>
    <main id="home-container">
        <h1 id="temp">SITE UNDER CONSTRUCTION</h1>
        <h1>Welcome!</h1>
        <h2>Leah Mattern - A Reasonably Tame Software Engineer.....</h2>
        <h3>Feel free to have a look around.</h3>
    </main>
    </Layout>
);

export default Home;